import { Button } from "@/components/ui/button";
import {
  isConversationSyncAssistantError,
  mapAssistantChatUserError,
} from "@/lib/assistant-chat-user-errors";

type Props = {
  error: Error;
  onStartNewConversation?: () => void | Promise<void>;
  startNewConversationLoading?: boolean;
};

export function AssistantChatErrorNotice({
  error,
  onStartNewConversation,
  startNewConversationLoading = false,
}: Props) {
  const message = mapAssistantChatUserError(error.message);
  const showNewConversation =
    Boolean(onStartNewConversation) && isConversationSyncAssistantError(error.message);

  return (
    <div
      className="space-y-2 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800 dark:border-red-900/50 dark:bg-red-950/40 dark:text-red-200"
      role="alert"
    >
      <p>{message}</p>
      {showNewConversation ? (
        <Button
          type="button"
          variant="outline"
          size="xs"
          disabled={startNewConversationLoading}
          onClick={() => void onStartNewConversation?.()}
        >
          {startNewConversationLoading ? "Resetting…" : "Start new conversation"}
        </Button>
      ) : null}
    </div>
  );
}
